import React from 'react';
import { motion } from 'framer-motion';
import { FiArrowRight } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const HubCard = ({ link, index }) => {
  const isComingSoon = link.isComingSoon;

  const CardWrapper = isComingSoon ? 'div' : 'a';
  const wrapperProps = isComingSoon ? {} : { href: link.url, target: '_blank', rel: 'noopener noreferrer' };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.1, duration: 0.5 }}
      className="h-full"
    >
      <CardWrapper 
        {...wrapperProps}
        className={`group block relative rounded-2xl overflow-hidden bg-white shadow-md border border-gray-100 h-full flex flex-col ${!isComingSoon && 'hover:shadow-xl hover:-translate-y-1 transition-all duration-300'}`}
      >
        <div className="relative h-48 w-full overflow-hidden shrink-0">
          <img 
            src={link.imageUrl} 
            alt={link.title} 
            className={`w-full h-full object-cover transition-transform duration-700 ${!isComingSoon && 'group-hover:scale-105'} ${isComingSoon ? 'grayscale opacity-70' : ''}`}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
          
          {isComingSoon && (
            <div className="absolute top-4 right-4 bg-brand-gold text-brand-dark text-xs font-bold px-3 py-1 rounded-full shadow-sm">
              Coming Soon
            </div>
          )}
        </div>

        <div className="p-6 flex flex-col flex-grow">
          <h3 className="text-xl font-bold text-brand-dark mb-3 font-serif">{link.title}</h3>
          {/* Added line-clamp to ensure long copy from the PDF doesn't break the grid layout */}
          <p className="text-gray-600 text-sm mb-6 flex-grow line-clamp-4 leading-relaxed">{link.description}</p>
          
          {!isComingSoon && (
            <div className="flex items-center text-brand-green font-semibold text-sm group-hover:text-brand-gold transition-colors mt-auto pt-4 border-t border-gray-50">
              Explore <SafeIcon icon={FiArrowRight} className="ml-2 transform group-hover:translate-x-1 transition-transform" />
            </div>
          )}
        </div>
      </CardWrapper>
    </motion.div>
  );
};

export default HubCard;